import { handleSetup, handleSubscribe } from "@api/Billing";
import { DSLinkButton } from "@components/design-system/molecules";
import { DSModal } from "@components/design-system/organisms";
import { UNLIMITED_PRICE_ID_MONTHLY } from "@src/constants";
import { useLocation } from "react-router";

export const ConfirmSetupBillingModal = ({
  shouldShow,
  setShouldShow,
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <DSModal
      isOpen={shouldShow}
      onClose={() => setShouldShow(false)}
      title="Just Checking In"
      dataTestId="setup-billing-modal"
      actions={[
        {
          label: "Cancel",
          variant: "cancel",
          onClick: () => setShouldShow(false),
        },
        {
          label: "Continue to Checkout",
          variant: "primary",
          onClick: () => handleSetup(window.location.href),
          dataTestId: "confirm-button",
        },
      ]}
    >
      <p>
        You are about to set up billing for this team. This will allow
        you and other team admins to upgrade team members to
        Scribenote Pro. If you are trying to upgrade your own account
        and do NOT wish for your billing information to be associated
        with your teams, please use the{" "}
        <DSLinkButton
          onClick={() =>
            handleSubscribe({
              priceId: UNLIMITED_PRICE_ID_MONTHLY,
              route: currentPath,
            })
          }
          dataTestId="upgrade-plan-link"
        >
          Upgrade Plan
        </DSLinkButton>{" "}
        button instead.
      </p>
      <p className="text-sm font-bold">
        *Note that setting up billing will not upgrade the accounts of
        any members of your teams. If desired, this can be done once
        setup is completed.
      </p>
    </DSModal>
  );
};
